import { useState } from "react";
import {
  Box,
  Container,
  Heading,
  // HStack,
  Stack,
  VStack,
  Breadcrumb,
  BreadcrumbItem,
  CircularProgress,
  Tag,
  TagLabel,
  // useDisclosure,
  // useToast,
  IconButton,
  Text,
  Image,
  FormControl,
} from "@chakra-ui/react";

import { ChevronRightIcon, CopyIcon } from "@chakra-ui/icons";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import Select from "components/Select/Select";

// import { ReactComponent as QrCode } from "assets/svg/qr-code.svg";

// import PinInput from "components/Input/PinInput";
// import Button from "components/Button/Button";
// import Select from "components/Select/Select";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import { useParams } from "react-router-dom";

import useWallet from "hooks/useWalletBalance";

import { useMemo } from "react";
import useCopy from "hooks/useCopy";
import toUpper from "lodash/toUpper";
import toLower from "lodash/toLower";

import constants from "config/constant";
// import toPrecision from "util/toPrecision";

const USDCWalletDeposit = ({ erc20, polygon, coin, isLoading }) => {
  const [network, setNetwork] = useState("erc20");

  const coinData = useMemo(() => {
    const map = {
      erc20,
      polygon,
    };

    return map[network ?? "erc20"];
  }, [network, erc20, polygon]);

  const { onCopy } = useCopy(coinData?.address);

  console.log("USDC COIN DATA", coinData);

  return (
    <Box
      bg="white"
      border="1px solid #8688942f"
      // minH="681px"
      w={["100%", "100%", "calc(100% - 25vw)"]}
      //   w="100%"
      mt="32px"
      borderRadius="16px"
      p="24px"
    >
      {isLoading && (
        <VStack py="32px">
          <CircularProgress
            ml="20px !important"
            isIndeterminate
            color="var(--primary)"
            size="20px"
          />
        </VStack>
      )}

      {!isLoading && (
        <Box>
          <FormControl maxW="xs">
            <Select
              label="Network"
              placeholder="Select Network"
              value={network ?? ""}
              onChange={(e) => setNetwork(e.target.value)}
            >
              <option value="erc20">Ethereum (ERC20)</option>
              <option value="polygon">Polygon (MATIC)</option>
            </Select>
          </FormControl>

          {network && coinData && (
            <Stack color="#14142B" mt="1.5em">
              <Box>
                <Text>1. Copy the address or scan the QR code</Text>
                <Tag
                  size="md"
                  // key={size}
                  variant="subtle"
                  bg="#EFF0F6"
                  p="7px 12px"
                >
                  <IconButton
                    size="xs"
                    variant="ghost"
                    aria-label="copy"
                    _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                    icon={<CopyIcon color="blue.400" />}
                    onClick={onCopy}
                  />
                  <TagLabel ml="5px" fontWeight="400" fontSize="md">
                    {coinData?.address}
                  </TagLabel>
                </Tag>
              </Box>

              <VStack py="28px">
                <Image
                  boxSize="200px"
                  src={coinData?.qrCode}
                  alt={`${coin}_address_qrCode`}
                />
              </VStack>
              {coin === "xlm" && (
                <Box my="10px !important">
                  <Text>
                    2. Kindly include the memo in your transaction. NB: This is
                    an extension of your Bitmama wallet and it helps us identify
                    and verify the fund owner
                  </Text>
                </Box>
              )}

              <Box my="10px !important">
                <Text>
                  {coin !== "xlm" ? "2" : "3"}. Once the transaction is
                  completed, you can click on the link to see the transaction
                  details on explorer.
                </Text>
              </Box>
            </Stack>
          )}
        </Box>
      )}
    </Box>
  );
};

const USDTWalletDeposit = ({ erc20, trc20, polygon, coin, isLoading }) => {
  const [network, setNetwork] = useState("trc20");

  const coinData = useMemo(() => {
    const map = {
      trc20,
      erc20,
      polygon,
    };

    return map[network ?? "erc20"];
  }, [network, erc20, trc20, polygon]);

  const { onCopy } = useCopy(coinData?.address);

  // console.log("USDT COIN DATA", coinData);

  return (
    <Box
      bg="white"
      border="1px solid #8688942f"
      // minH="681px"
      w={["100%", "100%", "calc(100% - 25vw)"]}
      //   w="100%"
      mt="32px"
      borderRadius="16px"
      p="24px"
    >
      {isLoading && (
        <VStack py="32px">
          <CircularProgress
            ml="20px !important"
            isIndeterminate
            color="var(--primary)"
            size="20px"
          />
        </VStack>
      )}

      {!isLoading && (
        <Box>
          <FormControl maxW="xs">
            <Select
              label="Network"
              placeholder="Select Network"
              value={network ?? ""}
              onChange={(e) => setNetwork(e.target.value)}
            >
              <option value="trc20">Tron (TRC20)</option>
              <option value="erc20">Ethereum (ERC20)</option>
              <option value="polygon">Polygon</option>
            </Select>
          </FormControl>

          {network && coinData && (
            <Stack color="#14142B" mt="1.5em">
              <Box>
                <Text>1. Copy the address or scan the QR code</Text>
                <Tag
                  size="md"
                  // key={size}
                  variant="subtle"
                  bg="#EFF0F6"
                  p="7px 12px"
                >
                  <IconButton
                    size="xs"
                    variant="ghost"
                    aria-label="copy"
                    _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                    icon={<CopyIcon color="blue.400" />}
                    onClick={onCopy}
                  />
                  <TagLabel ml="5px" fontWeight="400" fontSize="md">
                    {coinData?.address}
                  </TagLabel>
                </Tag>
              </Box>

              <VStack py="28px">
                <Image
                  boxSize="200px"
                  src={coinData?.qrCode}
                  alt={`${coin}_address_qrCode`}
                />
              </VStack>
              {coin === "xlm" && (
                <Box my="10px !important">
                  <Text>
                    2. Kindly include the memo in your transaction. NB: This is
                    an extension of your Bitmama wallet and it helps us identify
                    and verify the fund owner
                  </Text>
                </Box>
              )}

              <Box my="10px !important">
                <Text>
                  {coin !== "xlm" ? "2" : "3"}. Once the transaction is
                  completed, you can click on the link to see the transaction
                  details on explorer.
                </Text>
              </Box>
            </Stack>
          )}
        </Box>
      )}
    </Box>
  );
};

const OtherWalletDeposit = ({ coin, coinData, isLoading }) => {
  const { onCopy } = useCopy(coinData?.address);
  const { onCopy: onCopyMemo } = useCopy(coinData?.memo);

  return (
    <Box
      bg="white"
      border="1px solid #8688942f"
      // minH="681px"
      w={["100%", "100%", "calc(100% - 25vw)"]}
      //   w="100%"
      mt="32px"
      borderRadius="16px"
      p="24px"
    >
      {isLoading && (
        <VStack py="32px">
          <CircularProgress
            ml="20px !important"
            isIndeterminate
            color="var(--primary)"
            size="20px"
          />
        </VStack>
      )}

      {!isLoading && coinData && (
        <Stack color="#14142B">
          <Box d="block">
            <Text>1. Copy the address or scan the QR code</Text>
            <Tag
              size="md"
              // key={size}
              variant="subtle"
              bg="#EFF0F6"
              p="7px 12px"
            >
              <IconButton
                size="xs"
                variant="ghost"
                aria-label="copy"
                _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                icon={<CopyIcon color="blue.400" />}
                onClick={onCopy}
              />
              <TagLabel ml="5px" fontWeight="400" fontSize="md">
                {coinData?.address}
              </TagLabel>
            </Tag>
            {coin === "xlm" && (
              <Tag
                size="md"
                // key={size}
                variant="subtle"
                bg="#EFF0F6"
                p="7px 12px"
                mt="10px"
              >
                <IconButton
                  size="xs"
                  variant="ghost"
                  aria-label="copy"
                  _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                  icon={<CopyIcon color="blue.400" />}
                  onClick={onCopyMemo}
                />
                <TagLabel ml="5px" fontWeight="400" fontSize="md">
                  <strong>Memo:</strong> {coinData?.memo}
                </TagLabel>
              </Tag>
            )}
          </Box>

          <VStack py="28px">
            <Image
              boxSize="200px"
              src={coinData?.qrCode}
              alt={`${coin}_address_qrCode`}
            />
          </VStack>

          {/* <Box my="10px !important">
                    <Text>
                      2. Deposit fee : {toPrecision(coinDepositFee, coin)}
                    </Text>
                  </Box> */}

          {coin === "xlm" && (
            <Box my="10px !important">
              <Text>
                2. Kindly include the memo in your transaction. NB: This is an
                extension of your Bitmama wallet and it helps us identify and
                verify the fund owner
              </Text>
            </Box>
          )}

          <Box my="10px !important">
            <Text>
              {coin !== "xlm" ? "2" : "3"}. Once the transaction is completed,
              you can click on the link to see the transaction details on
              explorer.
            </Text>
          </Box>
        </Stack>
      )}
    </Box>
  );
};

const WalletDetailsDeposit = (props) => {
  const currentPage = "Wallet";

  const { getCoin, isLoading } = useWallet();

  console.log(props);

  const { coin } = useParams();

  // console.log("COIN", getCoin(coin));

  const coinData = useMemo(() => getCoin(coin), [coin, getCoin]);

  const usdtTron = useMemo(() => getCoin("usdt-tron"), [getCoin]);
  const usdtMatic = useMemo(() => getCoin("usdt-matic"), [getCoin]);
  const usdcMatic = useMemo(() => getCoin("usdc-matic"), [getCoin]);

  const renderDepositComponent = () => {
    const map = {
      [coin]: (
        <OtherWalletDeposit
          coin={coin}
          coinData={coinData}
          isLoading={isLoading}
        />
      ),
      usdt: (
        <USDTWalletDeposit
          trc20={usdtTron}
          erc20={coinData}
          polygon={usdtMatic}
          isLoading={isLoading}
        />
      ),
      usdc: (
        <USDCWalletDeposit
          erc20={coinData}
          polygon={usdcMatic}
          isLoading={isLoading}
        />
      ),
    };

    return map[coin ?? "usdt"];
  };

  // const coinDepositFee = useMemo(
  //   () => constants.coins[coin].wallet?.deposit?.fee,
  //   [coin]
  // );
  // const history = useHistory();
  // const toast = useToast();

  const isFiat = useMemo(() => constants.fiats.includes(toLower(coin)), [coin]);

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="cards">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW="container.xl">
            <Box px={["0", "0", "0"]}>
              <Heading fontSize="3xl">Wallet</Heading>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink
                    to={`/dashboard/wallet?tab=${isFiat ? "fiat" : "crypto"}`}
                  >
                    Wallet
                  </BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem>
                  <BreadcrumbLink to={`/dashboard/wallet/${coin}`}>
                    {toUpper(coin)}
                  </BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage href="#">
                    Deposit
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            {renderDepositComponent()}
          </Container>
        </Box>
      </Box>

      {/* <Confirmation
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={handleFreezeCard}
        title="Confirm Card Freeze"
      >
        <VStack>
          <Text>Are you sure you want to freeze this card?</Text>
        </VStack>
      </Confirmation> */}
    </Box>
  );
};

export default WalletDetailsDeposit;
